export const BILLING_SERVER_URL = process.env.REACT_APP_BILLING_BACKEND_URL;
// export const BILLING_SERVER_USER_URL =
//   process.env.REACT_APP_BILLING_BACKEND_USER_URL;
export const BILLING_SERVER_USER_URL =
  process.env.REACT_APP_BILLING_BACKEND_USER_URL;

export const callApi = async (method, endpoint, body, config) => {
  const result = await fetch(
    `${window.location.protocol}//${
      window.location.hostname
    }/growthzilla/remote/public${
      config?.isUser ? BILLING_SERVER_USER_URL : BILLING_SERVER_URL
    }${endpoint}`,
    {
      method,
      body: JSON.stringify(body),
      headers: {
        "Content-Type": "application/json",
      },
    }
  ).then((res) => res.json());

  return result;
};

export default {};
